import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

// Explicit and at the entry point, rather than trusting src/ui/index.ts's own
// `import './styles.css'` to carry through: package.json's tree-shaking lets
// Rollup drop a barrel's CSS import with no error and no warning, which ships
// the app completely unstyled. OTcalculator has been bitten by this before
// and guards it in CI — Task 6 adds the same guard here.
import './ui/styles.css'

// The app's own ground — html/body background, the .sl-app column rhythm —
// imported after the library stylesheet, on purpose. src/ui/base.css never
// touches html/body or declares .sl-app at all — that is the whole finding
// this file fixes: the library is scoped to .sl-root and leaves the page
// ground to whoever consumes it. But CSS resolves a specificity tie by
// source order, so if a future re-vendor of src/ui/ ever adds a rule at the
// same specificity as one here, "last import wins" is what keeps the app's
// ground able to override the library rather than the other way round.
// Importing app.css first would make that override depend on luck.
import './styles/app.css'

// Shift-code colours and their two consuming components (ShiftCodeChip,
// RosterShiftRow) — ShiftSwap-owned, after app.css for the same
// source-order reason app.css itself is imported after ui/styles.css above.
import './styles/shift-codes.css'

// BlockPicker and FourWeekConfirm's actions — ShiftSwap-owned, same
// source-order reasoning as shift-codes.css above.
import './styles/onboarding.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
